import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Popup from "reactjs-popup";
import { PopupMessage, InfoPopupMessage } from "../../utils/utils";
import axios from "axios";
import { clientAccess } from "../../utils/index";
import "bootstrap/dist/css/bootstrap.css";
import apiUrl from "../../apiUrlConstant";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import TopHeader from "../../layout/TopHeader";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

const YearArr = [];

for (var i = 2015; i <= 2030; i++) {
  YearArr.push(i)
}

class AssetDetails extends React.Component {
  state = {
    recordId: "",
    LandlordGroups: [],
    clientList: [],
    redirect: false,
    homeRedirect: false,
    assetTypes: [],
    assets: [],
    subAssets: [],
    countries: [],
    states: [],
    assets: [],
    districts: [],
    popupContent: "",
    messsagePopup: false,
    delete: false,
    cities: [],
    assetType: "",
    asset: "",
    subAsset: "",
    cityId: "",
    value: [],
    disableOnEdit: false,
    delete: false,
    currentIndex: null,
    showFirstAddBtn: true,
    url: `${apiUrl.apiUrl.url}/close-deal/create`,
    id: undefined,
    initialValues: {
      groupId: "",
      groupName: "",
      clientId: "",
      clientName: "",
      asset_name: "",
      asset_type: "",
      assetId: "",
      deal_type: "",
      value: "",
      assetTypeId: "",
      assetType: "",
      lessor_type: "",
      premises_area: "",
      land_area: "",
      landAreaArr: [0],
      premicesAreaArr: [0],
      building_area: "",
      buildingAreaArr: [0],
      carpet_area: "",
      carpetAreaArr: [0],
      gross_leaseable_area: "",
      grossLeaseableAreaArr: [0]
    },
  };

  resetForm(values) {
    this.state.initialValues = {
      landAreaArr: [0],
      premicesAreaArr: [0],
      buildingAreaArr: [0],
      carpetAreaArr: [0],
      grossLeaseableAreaArr: [0]
    };

    values.groupId = "";
    values.groupName = "";
    values.clientId = "";
    values.clientName = "";
    values.asset_name = "";
    values.assetId = "";
    values.asset_type = "";
    values.deal_type = "";
    values.lessor_spv = "";
    values.lessor_type = "";
    values.location = "";
    values.lessee_tenant = "";
    values.status = "";
    values.land_area = "";
    values.premises_area = "";
    values.car_parking_no = "";
    values.two_wheeler_parking_no = "";
    values.building_area = "";
    values.carpet_area = "";
    values.gross_leaseable_area = "";

    this.setState({});
  }

  constructor(props) {
    super(props);

  }

  componentDidMount() {
    console.log(this.props.match.params.id, "abc");
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  complianceList = (clientId, id) => {
    var ths = this;
    fetch(
      `${apiUrl.apiUrl.url}/compliance/get-list-asset?client_id=${clientId}&id=${id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "compliance data");
        // this.setState({
        //   assetCompliance: data.data,
        // });
        ths.state.initialValues.assetCompliance = data.data;
        ths.state.compliance_count = data.count;
        ths.state.compliance_percent = data.percent_count;
        ths.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };


  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/close-deal/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsageInfoPopup: true,
          popupInfoContent: "Sorry you cannot delete this deal",
        });
      } else {
        self.setState({
          delete: true,
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/close-deal/asset-details`,
          initialValues: {
            groupId: "",
            groupName: "",
            clientId: "",
            clientName: "",
            asset_name: "",
            assetId: "",
            asset_type: "",
            deal_type: "",
            assetTypeId: "",
            assetType: "",
            assetTypeId: "",
            assetType: "",
            landAreaArr: [0],
            premicesAreaArr: [0],
            buildingAreaArr: [0],
            carpetAreaArr: [0],
            grossLeaseableAreaArr: [0]
          },
        });
      } else {
        let self=this;
        axios.get(`${apiUrl.apiUrl.url}/close-deal/fetch-close-deal?id=${this.props.match.params.id}`).then((response) => {
          let data = response.data;
          self.setState({
            url: `${apiUrl.apiUrl.url}/close-deal/update?id=${self.props.match.params.id}`,
            initialValues: data.data,
            LandlordGroups: data.LandlordGroups,
            clientList: data.clientList,
          });
          self.state.initialValues.groupId = data.other_data.groupId;
          self.state.initialValues.groupName = data.other_data.groupName;
          self.state.initialValues.clientId = data.other_data.clientId;
          self.state.initialValues.clientName = data.other_data.clientName;
          self.state.initialValues.landAreaArr = data.data.land_area.split(",");
          self.state.initialValues.premicesAreaArr = data.data.premises_area.split(",");
          self.state.initialValues.buildingAreaArr = data.data.building_area.split(",");
          self.state.initialValues.carpetAreaArr = data.data.carpet_area.split(",");
          self.state.initialValues.grossLeaseableAreaArr = data.data.gross_leaseable_area.split(",");
          self.setState({});
        });

        // fetch(
        //   `${apiUrl.apiUrl.url}/close-deal/fetch-close-deal?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     console.log(data.data, "data.data");
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/close-deal/update?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       LandlordGroups: data.LandlordGroups,
        //       clientList: data.clientList,
        //     });
        //     this.state.initialValues.groupId = data.other_data.groupId;
        //     this.state.initialValues.groupName = data.other_data.groupName;
        //     this.state.initialValues.clientId = data.other_data.clientId;
        //     this.state.initialValues.clientName = data.other_data.clientName;
        //     this.state.initialValues.landAreaArr = data.data.land_area.split(",");
        //     this.state.initialValues.premicesAreaArr = data.data.premises_area.split(",");
        //     this.state.initialValues.buildingAreaArr = data.data.building_area.split(",");
        //     this.state.initialValues.carpetAreaArr = data.data.carpet_area.split(",");
        //     this.state.initialValues.grossLeaseableAreaArr = data.data.gross_leaseable_area.split(",");
        //     this.setState({});
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }
  resetCounter = () => {
    this.setState({ counter: Math.random() });
  }
  getalldeals = (id) => {
    fetch(
      `${apiUrl.apiUrl.url}/close-deal/fetch-close-deal?id=${id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.data, "data.data");
        this.setState({
          url: `${apiUrl.apiUrl.url}/close-deal/create?id=${this.props.match.params.id}`,
          initialValues: data.data,
        });

        //this.state.year = { 'value' : data.data.year, 'label':  data.data.year }
        //this.state.month = { 'value' : data.data.month, 'label':  data.data.month }
        this.setState({});
        console.log(this.state.initialValues, "initial values");
      })
      .catch((error) => {
        console.log(error);
      });
  }

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/close-deal/delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        ths.setState({
          messsageInfoPopup: true,
          popupInfoContent: "Something Went Wrong",
        });
      } else {
        ths.setState({
          messsageInfoPopup: true,
          popupInfoContent: "Data Deleted Successfully",
          homeRedirect: true
        });
      }
    });
  };
  resetCounter = () => {
    this.setState({ counter: Math.random() });
  }
  redirectToClose = () => {
    this.setState({ delete: false });
  };

  infoClose = () => {
    this.setState({
      redirect: false,
      messsageInfoPopup: false
    });
  }

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        asset_name: "",
        asset_type: "",
        assetId: "",
        deal_type: "",
        assetTypeId: "",
        assetType: "",
        assetTypeId: "",
        assetType: "",
        landAreaArr: [0],
        premicesAreaArr: [0],
        buildingAreaArr: [0],
        carpetAreaArr: [0],
        grossLeaseableAreaArr: [0]
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        asset_name: "",
        assetId: "",
        asset_type: "",
        deal_type: "",
        assetTypeId: "",
        assetType: "",
        assetTypeId: "",
        landAreaArr: [0],
        premicesAreaArr: [0],
        buildingAreaArr: [0],
        carpetAreaArr: [0],
        grossLeaseableAreaArr: [0]
      },
    });
  };

  addLandAreaRow = (arr) => {
    if (this.state.initialValues[arr] === undefined) {
      this.state.initialValues[arr] = [0];
    }
    this.state.initialValues[arr].push(0);
    if (this.state.initialValues[arr].length > 0) {
      this.setState({ showFirstAddBtn: false });
    }
    this.setState({});
  };

  removeLandAreaRow(element, arr) {
    console.log(element, "last elemnt", this.state.initialValues[arr]);
    this.state.initialValues[arr].splice(element, 1);
    if (this.state.initialValues[arr].length == 0) {
      this.state.initialValues[arr] = [0];
      this.setState({ showFirstAddBtn: true });
    }
    this.setState({});
  }


  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;

      this.complianceList(newValue.value, this.state.initialValues.assetId);
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.groupId = newValue;
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={"/close-deals/acquisition-details/" + this.state.recordId}
        />
      );
    }

    if (this.state.homeRedirect) {
      let url = this.props.match;

      this.state.homeRedirect = false;
      return (
        <Redirect
          push
          to={"/close-deals"}
        />
      );
    }

    return (
      <div className="parentContainer">
        <>
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li><Link to="/close-deals">Close Deals</Link></li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <a href="#">Asset Details</a>
                </li>
              </ul>
            </div>
          </div>

          <Formik
            initialValues={this.state.initialValues}
            enableReinitialize
            onSubmit={(values, actions) => {
              values.assetTypeId = this.state.initialValues.assetTypeId;
              values.assetId = this.state.initialValues.assetId;
              values.subAssetId = this.state.initialValues.subAssetId;
              console.log(values);
              var self = this;
              axios({
                method: "post",
                url: this.state.url,
                data: values,
              }).then(function (response) {
                if (!response.data.success) {
                  actions.setSubmitting(false);
                  actions.setErrors(response.data);
                } else {
                  self.setState({
                    messsagePopup: true,
                    popupContent: "Data Saved Successfully!",
                    recordId: response.data.id
                  });
                }
              });
            }}
          >
            {({
              values,

              errors,

              touched,

              handleChange,

              handleBlur,

              handleSubmit,

              isSubmitting,
            }) => (
              <>
                <div className="unitFormContainerNew">
                  <Form autoComplete="off" >
                    <div className="newGridSectionParent">
                      <div className="newGridSectionForFormMain">
                        {clientAccess() && (
                          <div className="newGridSectionInner">
                            <label>
                              Client Group <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="clientGroup"
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(e, "change_client_group");
                                }}
                                value={{
                                  label: this.state.initialValues.groupName,
                                  value: this.state.initialValues.groupId,
                                }}
                                options={this.state.LandlordGroups.map((item) => ({
                                  label: item.group_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="groupName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        )}

                        {clientAccess() && (
                          <div className="newGridSectionInner">
                            <label>
                              Client Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="clientName"
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(e, "change_client_name");
                                }}
                                value={{
                                  label: this.state.initialValues.clientName,
                                  value: this.state.initialValues.clientId,
                                }}
                                options={this.state.clientList.map((item) => ({
                                  label: item.client_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="clientName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        )}

                        <div className="newGridSectionInner">
                          <label>Asset Type <span className="astrik">*</span></label>
                          <div className="position-relative">
                            <Field
                              as="select"
                              name="asset_type"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="Warehouse" label="Warehouse" />
                              <option value="Office" label="Office" />
                              <option value="Retail" label="Retail" />
                              <option value="Industry" label="Industry" />
                            </Field>
                            <ErrorMessage
                              name="asset_type"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Asset Name <span className="astrik">*</span></label>
                          <div className="position-relative">
                            <Field type="text" name="asset_name" />
                            <ErrorMessage
                              name="asset_name"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Deal Type <span className="astrik">*</span></label>
                          <div className="position-relative">
                            <Field
                              as="select"
                              name="deal_type"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="Leasehold" label="Leasehold" />
                              <option value="Freehold" label="Freehold" />
                            </Field>
                            <ErrorMessage
                              name="deal_type"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Lessor / SPV</label>
                          <div className="position-relative">
                            <Field type="text" name="lessor_spv" />
                            <ErrorMessage
                              name="lessor_spv"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                        <div className="newGridSectionInner">
                          <label>Lessor Type</label>
                          <div className="position-relative">
                            <Field
                              as="select"
                              name="lessor_type"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="SPV" label="SPV" />
                              <option value="Anchor" label="Anchor" />
                            </Field>
                            <ErrorMessage
                              name="lessor_type"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Lessee / Tenant</label>
                          <div className="position-relative">
                            <Field type="text" name="lessee_tenant" />
                            <ErrorMessage
                              name="lessee_tenant"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Location</label>
                          <div className="position-relative">
                            <Field type="text" name="location" />
                            <ErrorMessage
                              name="location"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Status</label>
                          <div className="position-relative">
                            <Field
                              as="select"
                              name="status"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="Active" label="Active" />
                              <option value="Sold" label="Sold" />
                              <option value="Due Diligence" label="Due Diligence" />
                              <option value="Deed Execution" label="Deed Execution" />
                              <option value="Dropped" label="Dropped" />
                              <option value="Under Construction " label="Under Construction " />
                              <option value="Managed" label="Managed" />
                            </Field>
                            <ErrorMessage
                              name="status"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Land Area(SF)</label>
                          <div className="position-relative">
                            {this.state.initialValues.landAreaArr !== undefined && (
                              <div className="col-lg-12 mx-auto">
                                {this.state.initialValues.landAreaArr.map((name, index) => (
                                  <div key={index}>
                                    <input
                                      type="number"
                                      name={`land_area.${index}`}
                                      onChange={(e) => {
                                        this.state.initialValues.landAreaArr[index] = e.target.value;
                                        handleChange(e);
                                      }}
                                      value={this.state.initialValues.landAreaArr[index]}
                                    />
                                  </div>
                                ))}
                              </div>
                            )}
                            <ErrorMessage
                              name="land_area"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Premises Area</label>
                          <div className="position-relative">
                            {this.state.initialValues.premicesAreaArr !== undefined && (
                              <div className="col-lg-12 mx-auto">
                                {this.state.initialValues.premicesAreaArr.map((name, index) => (
                                  <div key={index}>
                                    <input
                                      type="number"
                                      name={`premises_area.${index}`}
                                      onChange={(e) => {
                                        this.state.initialValues.premicesAreaArr[index] = e.target.value;
                                        handleChange(e);
                                      }}
                                      value={this.state.initialValues.premicesAreaArr[index]}
                                    />
                                  </div>
                                ))}
                              </div>
                            )}
                            <ErrorMessage
                              name="premises_area"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Total Building Area</label>
                          <div className="position-relative">
                            {this.state.initialValues.buildingAreaArr !== undefined && (
                              <div className="col-lg-12 mx-auto">
                                {this.state.initialValues.buildingAreaArr.map((name, index) => (
                                  <div key={index}>
                                    <input
                                      type="number"
                                      name={`building_area.${index}`}
                                      onChange={(e) => {
                                        this.state.initialValues.buildingAreaArr[index] = e.target.value;
                                        handleChange(e);
                                      }}
                                      value={this.state.initialValues.buildingAreaArr[index]}
                                    />
                                  </div>
                                ))}
                              </div>
                            )}
                            <ErrorMessage
                              name="building_area"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Carpet Area</label>
                          <div className="position-relative">
                            {this.state.initialValues.carpetAreaArr !== undefined && (
                              <div className="col-lg-12 mx-auto">
                                {this.state.initialValues.carpetAreaArr.map((name, index) => (
                                  <div key={index}>
                                    <input
                                      type="number"
                                      name={`carpet_area.${index}`}
                                      onChange={(e) => {
                                        this.state.initialValues.carpetAreaArr[index] = e.target.value;
                                        handleChange(e);
                                      }}
                                      value={this.state.initialValues.carpetAreaArr[index]}
                                    />
                                  </div>
                                ))}
                              </div>
                            )}
                            <ErrorMessage
                              name="carpet_area"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Gross Leaseable Area</label>
                          <div className="position-relative">
                            {this.state.initialValues.grossLeaseableAreaArr !== undefined && (
                              <div className="col-lg-12 mx-auto">
                                {this.state.initialValues.grossLeaseableAreaArr.map((name, index) => (
                                  <div key={index}>
                                    <input
                                      type="number"
                                      name={`gross_leaseable_area.${index}`}
                                      onChange={(e) => {
                                        this.state.initialValues.grossLeaseableAreaArr[index] = e.target.value;
                                        handleChange(e);
                                      }}
                                      value={this.state.initialValues.grossLeaseableAreaArr[index]}
                                    />
                                  </div>
                                ))}
                              </div>
                            )}
                            <ErrorMessage
                              name="gross_leaseable_area"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Car Parking Spaces (No.)</label>
                          <div className="position-relative">
                            <Field type="number" name="car_parking_no" />
                            <ErrorMessage
                              name="car_parking_no"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>Two Wheeler Parking Spaces (No.)</label>
                          <div className="position-relative">
                            <Field type="number" name="two_wheeler_parking_no" />
                            <ErrorMessage
                              name="two_wheeler_parking_no"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                      </div>
                      {this.props.match.params.id !== undefined ? (
                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                          <button type="submit" disabled={isSubmitting} className="update_button">
                            Update
                          </button>

                          <button
                            type="button"
                            className="delete_button"
                            onClick={(e) => {
                              this.checkDelete(e);
                            }}
                          >
                            Delete
                          </button>

                          <button
                            type="reset"
                            onClick={this.redirectAfterEdit}
                            className="reset_button"
                          >
                            <Link to="/close-deals/asset-details">
                              Reset
                            </Link>
                          </button>
                        </div>
                      ) : (
                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                          <button type="submit" disabled={isSubmitting} className="add_button">
                            Add
                          </button>
                          <button
                            type="reset"
                            className="reset_button"
                          >
                            <Link
                              to="/close-deals/asset-details"
                              onClick={(e) => {
                                this.resetForm(values);
                              }}
                            >
                              Reset
                            </Link>
                          </button>
                        </div>
                      )}
                    </div>
                  </Form>
                </div>

                {/* <div className="unitFormContainerNew" >
                  <Form autoComplete="off" >
                    <div className="container">
                      <div className="row">
                        {clientAccess() && (
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Client Group <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Select
                                    className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                    name="clientGroup"
                                    //onInputChange={this.handleChange}
                                    onChange={(e) => {
                                      this.handleChangeLandlordGroup(
                                        e,
                                        "change_client_group"
                                      );
                                    }}
                                    value={{
                                      label: this.state.initialValues.groupName,
                                      value: this.state.initialValues.groupId,
                                    }}
                                    options={this.state.LandlordGroups.map(
                                      (item) => ({
                                        label: item.group_name,
                                        value: item.id,
                                      })
                                    )}
                                  />

                                  <ErrorMessage
                                    name="groupName"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {clientAccess() && (
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Client Name <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Select
                                    className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                    name="clientName"
                                    onChange={(e) => {
                                      this.handleChangeLandlordGroup(
                                        e,
                                        "change_client_name"
                                      );
                                    }}
                                    value={{
                                      label: this.state.initialValues.clientName,
                                      value: this.state.initialValues.clientId,
                                    }}
                                    options={this.state.clientList.map((item) => ({
                                      label: item.client_name,
                                      value: item.id,
                                    }))}
                                  />
                                  <ErrorMessage
                                    name="clientName"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Asset Type <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Field
                                  as="select"
                                  name="asset_type"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  <option value="Warehouse" label="Warehouse" />
                                  <option value="Office" label="Office" />
                                  <option value="Retail" label="Retail" />
                                  <option value="Industry" label="Industry" />
                                </Field>
                                <ErrorMessage
                                  name="asset_type"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Asset Name <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Field type="text" name="asset_name" />
                                <ErrorMessage
                                  name="asset_name"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Deal Type <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Field
                                  as="select"
                                  name="deal_type"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  <option value="Leasehold" label="Leasehold" />
                                  <option value="Freehold" label="Freehold" />
                                </Field>
                                <ErrorMessage
                                  name="deal_type"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Lessor / SPV
                              </label>
                              <div className="col-sm-7">
                                <Field type="text" name="lessor_spv" />
                                <ErrorMessage
                                  name="lessor_spv"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>



                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Lessor Type
                              </label>
                              <div className="col-sm-7">
                                <Field
                                  as="select"
                                  name="lessor_type"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  <option value="SPV" label="SPV" />
                                  <option value="Anchor" label="Anchor" />
                                </Field>
                                <ErrorMessage
                                  name="lessor_type"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Lessee / Tenant
                              </label>
                              <div className="col-sm-7">
                                <Field type="text" name="lessee_tenant" />
                                <ErrorMessage
                                  name="lessee_tenant"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Location
                              </label>
                              <div className="col-sm-7">
                                <Field type="text" name="location" />
                                <ErrorMessage
                                  name="location"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Status
                              </label>
                              <div className="col-sm-7">
                                <Field
                                  as="select"
                                  name="status"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  <option value="Active" label="Active" />
                                  <option value="Sold" label="Sold" />
                                  <option
                                    value="Due Diligence"
                                    label="Due Diligence"
                                  />
                                  <option
                                    value="Deed Execution"
                                    label="Deed Execution"
                                  />
                                  <option value="Dropped" label="Dropped" />
                                  <option
                                    value="Under Construction "
                                    label="Under Construction "
                                  />
                                  <option value="Managed" label="Managed" />
                                </Field>
                                <ErrorMessage
                                  name="status"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Land Area(SF)
                              </label>
                              <div className="col-sm-7">

                                {this.state.initialValues.landAreaArr !=
                                  undefined && (
                                    <div className="col-lg-12 mx-auto">
                                      {this.state.initialValues.landAreaArr.map(
                                        (name, index) => (
                                          <div>
                                            <input type="number" name={`land_area.${index}`}
                                              onChange={(e) => {
                                                this.state.initialValues.landAreaArr[
                                                  index
                                                ] = e.target.value;
                                                handleChange(e);
                                              }}
                                              value={
                                                this.state.initialValues
                                                  .landAreaArr[index]
                                              }
                                            />
                                          </div>
                                        ))}
                                    </div>
                                  )}
                                <ErrorMessage
                                  name="land_area"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>




                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Premises Area
                              </label>
                              <div className="col-sm-7">
                                {this.state.initialValues.premicesAreaArr !=
                                  undefined && (
                                    <div className="col-lg-12 mx-auto">
                                      {this.state.initialValues.premicesAreaArr.map(
                                        (name, index) => (
                                          <div>
                                            <input type="number" name={`premises_area.${index}`}
                                              onChange={(e) => {
                                                this.state.initialValues.premicesAreaArr[
                                                  index
                                                ] = e.target.value;
                                                handleChange(e);
                                              }}
                                              value={
                                                this.state.initialValues
                                                  .premicesAreaArr[index]
                                              }
                                            />

                                          </div>
                                        ))}
                                    </div>
                                  )}
                                <ErrorMessage
                                  name="premises_area"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Total Building Area
                              </label>
                              <div className="col-sm-7">

                                {this.state.initialValues.buildingAreaArr !=
                                  undefined && (
                                    <div className="col-lg-12 mx-auto">
                                      {this.state.initialValues.buildingAreaArr.map(
                                        (name, index) => (
                                          <div>
                                            <input type="number" name={`building_area.${index}`}
                                              onChange={(e) => {
                                                this.state.initialValues.buildingAreaArr[
                                                  index
                                                ] = e.target.value;
                                                handleChange(e);
                                              }}
                                              value={
                                                this.state.initialValues
                                                  .buildingAreaArr[index]
                                              }
                                            />

                                          </div>
                                        ))}
                                    </div>
                                  )}
                                <ErrorMessage
                                  name="building_area"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Carpet Area
                              </label>
                              <div className="col-sm-7">

                                {this.state.initialValues.carpetAreaArr !=
                                  undefined && (
                                    <div className="col-lg-12 mx-auto">
                                      {this.state.initialValues.carpetAreaArr.map(
                                        (name, index) => (
                                          <div>
                                            <input type="number" name={`carpet_area.${index}`}
                                              onChange={(e) => {
                                                this.state.initialValues.carpetAreaArr[
                                                  index
                                                ] = e.target.value;
                                                handleChange(e);
                                              }}
                                              value={
                                                this.state.initialValues
                                                  .carpetAreaArr[index]
                                              }
                                            />

                                          </div>
                                        ))}
                                    </div>
                                  )}
                                <ErrorMessage
                                  name="carpet_area"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Gross Leaseable Area
                              </label>
                              <div className="col-sm-7">

                                {this.state.initialValues.grossLeaseableAreaArr !=
                                  undefined && (
                                    <div className="col-lg-12 mx-auto">
                                      {this.state.initialValues.grossLeaseableAreaArr.map(
                                        (name, index) => (
                                          <div>
                                            <input type="number" name={`gross_leaseable_area.${index}`}
                                              onChange={(e) => {
                                                this.state.initialValues.grossLeaseableAreaArr[
                                                  index
                                                ] = e.target.value;
                                                handleChange(e);
                                              }}
                                              value={
                                                this.state.initialValues
                                                  .grossLeaseableAreaArr[index]
                                              }
                                            />

                                          </div>
                                        ))}
                                    </div>
                                  )}
                                <ErrorMessage
                                  name="gross_leaseable_area"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Car Parking Spaces (No.){" "}
                              </label>
                              <div className="col-sm-7">
                                <Field type="number" name="car_parking_no" />
                                <ErrorMessage
                                  name="car_parking_no"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Two Wheeler Parking Spaces (No.)
                              </label>
                              <div className="col-sm-7">
                                <Field type="number" name="two_wheeler_parking_no" />
                                <ErrorMessage
                                  name="two_wheeler_parking_no"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>



                        {this.props.match.params.id !== undefined ? (
                          <div className="row">
                            <div className="col-lg-6 offset-lg-6">
                              <div className="btnContainer">
                                <div>
                                  <button type="submit" disabled={isSubmitting}>
                                    Update
                                  </button>

                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      this.checkDelete(e);
                                    }}
                                  >

                                    Delete
                                  </button>

                                  <button
                                    type="reset"
                                    onClick={this.redirectAfterEdit}
                                  >
                                    <Link to="/close-deals/asset-details">
                                      Reset
                                    </Link>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="row">
                            <div className="col-12 col-sm-8 col-md-12">
                              <div className="btnContainer">
                                <div>
                                  <button type="submit" disabled={isSubmitting}>
                                    Add
                                  </button>
                                  <button
                                    type="reset"
                                  // onClick={this.redirectAfterEdit}
                                  >
                                    <Link
                                      to="/close-deals/asset-details"
                                      onClick={(e) => {
                                        this.resetForm(values);
                                      }}
                                    >
                                      Reset
                                    </Link>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Form>
                </div> */}
              </>
            )}
          </Formik>
          <PopupMessage
            open={this.state.messsagePopup}
            content={this.state.popupContent}
            redirectAfterSave={this.redirectAfterSave}
          />
          <InfoPopupMessage
            open={this.state.messsageInfoPopup}
            content={this.state.popupInfoContent}
            infoClose={this.infoClose}
            infoOk={this.infoClose}
          />
          <Popup open={this.state.delete} position="top center">
            {(close) => (
              <div>
                "Delete the item?"
                <a className="close" onClick={this.redirectToClose}>
                  &times;
                </a>
                <div>
                  <button type="button" onClick={this.redirectToDelete}>
                    Yes
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </>
      </div>

    );
  }
}
export default withRouter(AssetDetails);












